import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { heroReveal } from "@/lib/motion";
import { ShieldCheck, ScrollText, Cookie, LifeBuoy, ArrowUpRight } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const pages = [
  { to: "/privacy", icon: ShieldCheck, title: "Privacy Policy", desc: "How Emergo collects, uses, stores, and protects your data." },
  { to: "/terms", icon: ScrollText, title: "Terms of Service", desc: "The terms that govern your use of the Emergo app." },
  { to: "/cookies", icon: Cookie, title: "Cookie Notice", desc: "How Emergo uses cookies and similar technologies." },
  { to: "/support", icon: LifeBuoy, title: "Support", desc: "Get help or send our team a message directly." },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.08, delayChildren: 0.1 } },
};
const item = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-ink antialiased flex flex-col" data-testid="landing-page">
      <Header />

      <main className="mx-auto w-full max-w-3xl px-6 flex-1">
        <motion.div
          {...heroReveal}
          className="pt-20 pb-10"
        >
          <p className="text-xs uppercase tracking-[0.08em] font-bold text-brand mb-4">Emergo</p>
          <h1 className="font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-ink" data-testid="page-title">
            Legal &amp; Support
          </h1>
          <p className="mt-6 text-lg text-ink-2 max-w-xl leading-relaxed">
            Everything you need in one place — our policies and a direct line to our team. Choose a page below.
          </p>
        </motion.div>

        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="grid gap-4 sm:grid-cols-2 pb-16"
        >
          {pages.map((p) => (
            <motion.div key={p.to} variants={item}>
              <Link
                to={p.to}
                data-testid={`home-link-${p.to.replace("/", "")}`}
                className="group block h-full rounded-2xl border border-gray-200 bg-white p-6 transition-colors hover:border-brand"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-brand-soft text-brand transition-transform group-hover:scale-105">
                    <p.icon className="h-[18px] w-[18px]" strokeWidth={1.75} />
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-gray-300 transition-colors group-hover:text-brand" strokeWidth={1.75} />
                </div>
                <h2 className="mt-5 font-extrabold tracking-tight text-xl text-ink">{p.title}</h2>
                <p className="mt-2 text-[15px] leading-relaxed text-ink-2">{p.desc}</p>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
